// extracted by mini-css-extract-plugin
export var content = "addToKitModal-module--content--1d5fd";
export var kitDropdown = "addToKitModal-module--kitDropdown--652ec";
export var warehouseDropdown = "addToKitModal-module--warehouseDropdown--dfac7";